import { Arrow } from '../../utils/editorReactIcons';
export { Arrow };
export default Arrow;
